import { Box, Icon } from "@chakra-ui/react";
import IconAdd from "assets/icons/icon-add.svg?react";
import {
  ChakraStylesConfig,
  CreatableSelect,
  CreatableSelectComponent,
  MultiValue,
  OptionBase,
  Props as ReactSelectBaseProps,
  Select,
  SelectComponent,
  SingleValue,
} from "chakra-react-select";
import { useResourceList } from "hooks/useResourceList";
import { useEffect, useState } from "react";
import { useController, UseControllerProps } from "react-hook-form";
import { useCreateSelectOption } from "./CustomCreatableSelect/useCreateSelectOption";

interface Option extends OptionBase {
  label: string;
  value: string;
}

export type SelectOption = Option | null;

interface ResourceSelectProps extends ReactSelectBaseProps {
  name: string;
  resourceKey: string;
  listPath: string;
  listParams?: object;
  nameFormat?: (record: object) => string;
}

interface ResourceCreatableSelectProps extends ResourceSelectProps {
  createPath: string;
  createData?: object;
}

interface ResourceSelectBaseProps {
  as: CreatableSelectComponent | SelectComponent;
}

type OptionValue = MultiValue<Option> | SingleValue<Option> | undefined;

function CreateLabel(inputValue: string) {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap="12px"
      borderRadius="10px"
      bgColor="bg.button.primary"
      p="10px"
      w="full"
    >
      <Icon as={IconAdd} boxSize="20px" mr="12px" />
      <Box color="white">{`Criar e selecionar: "${inputValue}"`}</Box>
    </Box>
  );
}

export function ResourceCreatableSelect(props: ResourceCreatableSelectProps) {
  return <ResourceSelectBase as={CreatableSelect} {...props} />;
}

export function ResourceSelect(props: ResourceSelectProps) {
  return <ResourceSelectBase as={Select} {...props} />;
}

function ResourceSelectBase({
  as: Component,
  ...props
}: ResourceSelectBaseProps &
  ResourceSelectProps &
  UseControllerProps & { createData?: object; createPath?: string }) {
  const {
    resourceKey,
    listPath,
    nameFormat,
    listParams = {},
    createPath = "",
    createData = {},
    name,
    control,
    rules,
    ...rest
  } = props;
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
  });

  const [options, setOptions] = useState<Option[]>([]);

  const { data: rows = [] } = useResourceList({
    resourceName: resourceKey,
    path: listPath,
    params: listParams,
  });

  useEffect(() => {
    setOptions(
      rows?.map((record) => {
        const { id: value, name: label, colorScheme } = record;
        return {
          value,
          label: nameFormat ? nameFormat(record) : label,
          colorScheme,
        };
      })
    );
  }, [rows]);

  const { isPending, onCreateSelectOption } = useCreateSelectOption({
    resourceName: resourceKey,
    path: createPath,
    createData,
    onSuccess: ({ data: record }) => {
      const newOption = {
        label: nameFormat ? nameFormat(record) : record.name,
        value: record.id,
        colorScheme: record.colorScheme,
      };
      setOptions((state) => [...state, newOption]);
      const selectValue = rest.isMulti
        ? Array.isArray(value)
          ? [...value, newOption]
          : [newOption]
        : newOption;
      setTimeout(() => onChange(selectValue), 10);
    },
  });

  return (
    <Component
      ref={ref}
      value={value}
      options={options}
      isDisabled={isPending}
      isLoading={isPending}
      onChange={onChange}
      onBlur={onBlur}
      onCreateOption={onCreateSelectOption}
      formatCreateLabel={CreateLabel}
      noOptionsMessage={() => "Nenhuma opção"}
      createOptionPosition="first"
      aria-label="teste"
      components={
        {
          // Input: (props) => {
          //   return <Input bgColor="red" {...props} />;
          // },
        }
      }
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (provided) => ({
          ...provided,
          // This is the z-index of the normal select in Chakra.
          zIndex: "var(--chakra-z-index-dropdown)",
        }),
      }}
      chakraStyles={chakraStyles}
      {...rest}
    />
  );
}

const chakraStyles: ChakraStylesConfig = {
  // inputContainer: (provided, state) => {
  //   console.log(state);
  //   console.log(provided);
  //   return {
  //     ...provided,
  //     _after: {
  //       visibility: "visible !important",
  //       content: state.isFocused
  //         ? `attr(data-value) "Digite o valor" !important`
  //         : `attr(data-value) " "`,
  //     },
  //   };
  // },
  //input: (provided, state) => {
  //},
  // option: () => ({
  //   fontSize: "14px",
  //   fontWeight: 500,
  //   letterSpacing: "-0.084px",
  //   display: "flex",
  //   alignItems: "center",
  //   whiteSpace: "nowrap",
  //   svg: {
  //     boxSize: "32px",
  //     mr: "12px",
  //   },
  //   _selected: {
  //     bgColor: "#EFFAF6",
  //   },
  // }),
};
